module.exports = __webpack_public_path__ + "img/Weapon_07.c5460ce5.png";